import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { I18nProvider } from "@/i18n";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentStatus";
import { Terms, Privacy, About } from "@/pages/Legal";
import Admin from "@/pages/Admin";
import Resources from "@/pages/resources/Resources";
import { Contact, Security, NotFound } from "@/pages/MiscPages";
import ResourceArticle from "@/pages/resources/ResourceArticle";
import Guarantee from "@/pages/Guarantee";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SupportChat } from "@/components/SupportChat";
import { captureRefEmail } from "@/lib/track";

function App() {
  useEffect(() => {
    captureRefEmail();
  }, []);
  return (
    <HelmetProvider>
      <I18nProvider>
        <div className="App">
          <ErrorBoundary>
            <BrowserRouter>
              <Toaster position="top-right" richColors closeButton />
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/workspace" element={<Dashboard />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/about" element={<About />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/resources/isbp745-bill-of-lading-checklist" element={<Navigate to="/resources/isbp821-bill-of-lading-checklist" replace />} />
                <Route path="/resources/:slug" element={<ResourceArticle />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/security" element={<Security />} />
                <Route path="/guarantee" element={<Guarantee />} />
                <Route path="/pricing" element={<Navigate to="/#pricing" replace />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
              <SupportChat />
            </BrowserRouter>
          </ErrorBoundary>
        </div>
      </I18nProvider>
    </HelmetProvider>
  );
}

export default App;
